import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { FavouritesServiceResponse } from "../services/favourites-service";
import { VehicleData } from "../types";

interface VehicleStoreInterface {
    requestUrl: string | null,
    setRequestUrl: (url : string | null) => void,
    response: FavouritesServiceResponse | null,
    setResponse: (response: FavouritesServiceResponse | null) => void,
    vehicle: VehicleData | null,
    setVehicle: (data: FavouritesServiceResponse | null) => void,
    vehicles: VehicleData[] | null,
    setVehicles: (data: FavouritesServiceResponse | null) => void
}

export const useVehicleStore = create<VehicleStoreInterface>()(devtools((set) => ({
        requestUrl: null,
        setRequestUrl: (url) => set(() => ({requestUrl : url})),
        response: null,
        setResponse: (response) => set(() => ({ response })),
        vehicle: null,
        setVehicle: (data) => {
            if(data && data.data) {
                let vehicle = data.data[0];

                set(() => ({ vehicle }));
            }
            else if(data === null) {
                set(() => ({ vehicle: null }));
            }
        },
        vehicles: null,
        setVehicles: (data) => {
            if (data && data.data) {
                let vehicles = data.data;

                set(() => ({ vehicles }));
            }
        },
})));
